var React = require('react');

function Messages (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-796 -369)"},[React.createElement("path",{"d":"M21,15a1,1,0,0,1-.707-.293L17.586,12H11a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h9a2,2,0,0,1,2,2V14a1,1,0,0,1-1,1ZM11,4v6h7a1,1,0,0,1,.707.293L20,11.586V4Z","transform":"translate(794 367)","key":0}),React.createElement("path",{"d":"M3,22a1,1,0,0,1-1-1V11A2,2,0,0,1,4,9H6a1,1,0,0,1,0,2H4v7.586l1.293-1.293A1,1,0,0,1,6,17h7V15a1,1,0,0,1,2,0v2a2,2,0,0,1-2,2H6.414L3.707,21.707A1,1,0,0,1,3,22Z","transform":"translate(794 367)","key":1})]));
}

Messages.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 20 20","stroke":"currentcolor","fill":"currentcolor","strokeWidth":"0"};

module.exports = Messages;

Messages.default = Messages;
